import request from '@/utils/request'

/** 广告渠道列表 */
export function getAdsChannelList(data) {
  return request({
    url: '/api/v1/admin/ads/channel/list',
    method: 'post',
    mock: false,
    data,
  })
}

/** 广告渠道详情 */
export function getAdsChannelDetail(data) {
  return request({
    url: '/api/v1/admin/ads/channel/detail',
    method: 'post',
    mock: false,
    data,
  })
}

/** 创建广告渠道 */
export function createAdsChannel(data) {
  return request({
    url: '/api/v1/admin/ads/channel/create',
    method: 'post',
    mock: false,
    data,
  })
}

/** 更新广告渠道 */
export function updateAdsChannel(data) {
  return request({
    url: '/api/v1/admin/ads/channel/update',
    method: 'post',
    mock: false,
    data,
  })
}

/** 删除广告渠道 */
export function deleteAdsChannel(data) {
  return request({
    url: '/api/v1/admin/ads/channel/delete',
    method: 'post',
    mock: false,
    data,
  })
}
